import propTypes from 'prop-types';
import EmployeDashboardInfo from './EmployeDashboardInfo';
import EmployeDashboardChart from './EmployeeDashboardChart';
import {useCallback, useEffect, useReducer} from 'react';
import {formatPeriodDate} from '../../lib/dateTimesHelpers';
import {useDispatch} from 'react-redux';
import {getAllGraphicData, getLastThreePeriodsData} from './business/dashboardBusiness';
import {calculateCategoryScores, groupQuestionsByCategoryAndPeriod, seriesCreator} from '../../lib/chartDataHelper';
import {DashboardActionTypes} from '../../const/dataEnum';
import {extractTextValues} from '../../lib/utilities';
import {EnhancedDashboardReducer, InitialState} from './stores/dashboardReducer';
import {DashboardContext} from '../../lib/contexLib';


const EmployeeDashbord = ({ periode, currentPeriod }) => {
  const [dashboardState, dispatchDashboard] = useReducer(EnhancedDashboardReducer, InitialState);
  const reduxDispatch = useDispatch();

  const fetchData = useCallback(async () => {
    try {
      const fetchPeriod = await reduxDispatch(getLastThreePeriodsData());
      const periodData = fetchPeriod;
      const periods = periodData.map((period) => ({
        id: period.id,
        text: formatPeriodDate(period.period),
        data: period,
     }));

      const response = await reduxDispatch(getAllGraphicData());
      if (response.length > 0) {
        const labelsArray = response[0].questionLabels.map((label, index) => ({
          label: label.skillName,
          id: index,
       }));
        const grouped = groupQuestionsByCategoryAndPeriod(response[0].personalGraphicDataList);
        const resGrouped = calculateCategoryScores(grouped, periods);
        const groupedToSeries = seriesCreator(resGrouped);

        dispatchDashboard({
          type: DashboardActionTypes.SET_DASHBOARD_DATA,
          payload: {
            groupedData: groupedToSeries,
            categoryScore:  {...resGrouped},
            chartData: response,
            xData: extractTextValues(periods),
            questionCategory: labelsArray,
         },
       });
     }
   } catch (error) {
      console.error("Error fetching data:", error);
   }
 }, [reduxDispatch, dispatchDashboard]);

  // Trigger fetch on component mount.
  useEffect(() => {
    fetchData();
 }, [fetchData]);  


  return (
    <>
      <DashboardContext.Provider value={{dashboardState, dispatchDashboard}}>
        <EmployeDashboardInfo periods={periode} currentPeriod={currentPeriod} />
        <div className="dashboard-graph">
          <EmployeDashboardChart />
        </div>
      </DashboardContext.Provider>
    </>
  ) 
};

EmployeeDashbord.defaultProps = {
  periode: '2024H1',
};

EmployeeDashbord.propTypes = {
  periode: propTypes.string,
};

export default EmployeeDashbord;
